(function () {
    'use strict';

    angular
        .module('reports')
        .config(config);

    config.$inject = ['$provide', app.modules.common.constants.appsettings];
    function config($provide, ggSettings) {
        var root = ggSettings.grpapi.root;
        $provide.constant('URLS', {
            fetchScoresReport: root + "groups({0})/getScoresReport(startDate={1},endDate={2},scoreType='{3}')",
            fetchWagersReport: root + "groups({0})/getWagersReport(startDate={1},endDate={2})",
            fetchHandicapsReport: root + "groups({0})/getHandicapsReport(startDate={1},endDate={2})",
            fetchStatsReport: root + "groups({0})/getStatsReport(startDate={1},endDate={2},scoreType='{3}')"
        });
    }
})();